import React, { Suspense, useEffect, useRef, useState } from "react";
import { StyledLottieContainer } from "./LottieAnimation.styles";
import { type ILottie, type LottieJSON } from "@lottielab/lottie-player/react";

export const LottieAnimation = ({
  animationData,
  isInView,
}: Readonly<{
  animationData: unknown;
  isInView?: boolean;
}>) => {
  const ref = useRef<ILottie | null>(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (animationData !== data && !!ref.current) {
      setData(animationData);

      try {
        ref.current.currentTime = 0;
        ref.current?.play();
      } catch (error) {
        console.error("Error playing Lottie animation:", error);
      }
    }
  }, [animationData, data]);

  useEffect(() => {
    if (isInView && !!ref.current) {
      try {
        ref.current.currentTime = 0;
        ref.current?.play();
      } catch (error) {
        console.error("Error playing Lottie animation:", error);
      }
    } else {
      ref.current?.pause();
    }
  }, [isInView]);

  return (
    <Suspense fallback={null}>
      <StyledLottieContainer
        ref={ref}
        lottie={animationData as LottieJSON}
        autoplay={true}
        loop={false}
      />
    </Suspense>
  );
};
